export default "__VITE_ASSET__Bq5FB6sU__"